import React from 'react';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import ResultPage from './ResultPage';
import LoadingScreen from './LoadingScreen';
import NumberFormat from 'react-number-format';
import { withStyles } from '@material-ui/core/styles';

class AmountsPage extends React.Component {

    apiRoot = window.MAM.apiRootUrl;
    siteId = window.MAM.siteId;
    widgetConfig = this.props.config;

    state = {

        homeValue: 250000,
        downPayment: 100000,
        veteran: false,
        
        results: null,
        loanOptions: null,
        legalDisclaimer: null,
    };

    formatCurrency = (amt) => {
        var fmtr = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        return fmtr.format(amt).replace(/\.0+$/, "");
    };

    componentDidMount() {
        console.log("Mounted!");
        console.log(this.widgetConfig);
        
        var component = this;
        axios.get(`${this.apiRoot}rates/current/json/${this.siteId}`)
            .then(function (response) {
                
                component.setState({
                    loanOptions: response.data.rates,
                    ratesEffectiveNotice: response.data.effectiveNotice,
                    legalDisclaimer: response.data.assumptions,
                    institutionId: response.data.institutionId
                });
                console.log('Rates loaded');
                console.log(response);
            })
            .catch(function (error) {
                console.log('Error loading Rates');
                console.log(error);
            });
    }

    handleChange = (event) => {

        var name = event.target.name;
        var val = event.target.value;

        if (name === 'homeValue' || name === 'downPayment') {
            val = val.replace(/\,/g, '').replace(/\$/g, '');
        }

        let state = {...this.state }

        if (name == 'homeValue') {
            state['downPayment'] = val * .20;
        }
        
        state[name] = val;
        this.setState(state);
    };


    calculate = () => {

        var component = this;
        
        this.setState({ results: null, loading: true }, function() {

            var homeValue = Number(component.state.homeValue);
            var downPayment = Number(component.state.downPayment);
            var isVeteran = component.state.veteran;
            
            var data = { 
                siteId : component.siteId,
                purchaseAmount: homeValue,
                downPayment: downPayment,
                isVeteran: isVeteran,
                config: component.widgetConfig
            };
            
            axios.post(`${component.apiRoot}paymentCalculator/calculate`, data).then(function(response) { 
                
                var results = [];

                console.log(response.data);

                results = response.data;

                if (homeValue != 81258609) {
                    component.setState({ results : results, loading: false })
                }
            });

            var logData = JSON.parse(JSON.stringify(data));
            logData.config = null;
            window.MAM.logActivity(this.widgetConfig.id, 'PaymentCalculator', 'Calculate', logData);
        });

    };

    learnMore = (product) => {
        
        // Lead Capture
        var params = {
            WidgetId: this.widgetConfig.id,
            Widget: 'PaymentCalculator',
            Product: product,
            PurchasePrice: this.state.homeValue,
            DownPayment: this.state.downPayment,
            VeteranOrMilitary: !!this.state.veteran
        };
        
        switch (this.widgetConfig.linkUrl.toUpperCase())
        {
            case "LEADCAPTURE":
                console.log("Params", params);
                window.MAM.leadCaptureModalShow(params);
                break;
            default:
                window.location.href = this.widgetConfig.linkUrl;
                break;
        }
    };

    reset = () => {
        this.setState({ results: null });
    };

    render() {

        return (
            <div>
                { this.widgetConfig &&
                    <div>
                        { !this.state.results && !this.state.loading &&
                            <div>
                                <div className={`mam-question-value`}>
                                    <div className={`mam-question-value-label`}>
                                        What is the value of your house?
                                    </div>
                                    <NumberFormat 
                                        thousandSeparator={true} 
                                        prefix={'$'}
                                        required
                                        id="homeValue"
                                        name="homeValue"
                                        value={this.state.homeValue}
                                        className={`mam-question-value-input`}
                                        variant={'outlined'}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className={`mam-question-down`}>
                                    <div className={`mam-question-down-label`}>
                                        How much are you going to put down?
                                    </div>
                                    <NumberFormat 
                                        thousandSeparator={true} 
                                        prefix={'$'}
                                        required
                                        id="downPayment"
                                        name="downPayment"
                                        value={this.state.downPayment}
                                        className={`mam-question-down-input`}
                                        variant={'outlined'}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className={`mam-question-veteran`}>
                                    <div className={`mam-question-veteran-label`}>
                                        {this.widgetConfig.veteranQuestionText} 
                                    </div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.setState({ veteran: true })}
                                        className={`mam-btn mam-question-veteran-yes ${this.state.veteran ? "mam-btn-selected" : ""}`}
                                    > Yes
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.setState({ veteran: false })}
                                        className={`mam-btn mam-question-veteran-no ${!this.state.veteran ? "mam-btn-selected" : ""}`}
                                    > No
                                    </Button>
                                </div>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={`mam-btn mam-calculate`}
                                    onClick={this.calculate}
                                > CALCULATE
                                </Button>
                            </div>
                        }

                        { this.state.results && !this.state.loading &&
                            <div className={`mam-results-page`}>
                                <div className={`mam-results-params`}>
                                    <div className={`mam-results-params-homevalue`}>
                                        <div className={`mam-results-params-homevalue-label`}>Home Value</div>
                                        <div className={`mam-results-params-homevalue-value`}>{this.formatCurrency(this.state.homeValue)}</div>
                                    </div>
                                    <div className={`mam-results-params-downpayment`}>
                                        <div className={`mam-results-params-downpayment-label`}>Down Payment</div>
                                        <div className={`mam-results-params-downpayment-value`}>{this.formatCurrency(this.state.downPayment)}</div>
                                    </div>
                                    <div className={`mam-results-params-veteran`}>
                                        <div className={`mam-results-params-veteran-label`}>Active Duty/Veteran?</div>
                                        <div className={`mam-results-params-veteran-value`}>{ this.state.veteran ? "Yes" : "No" }</div>
                                    </div>
                                </div>
                                <div className={`mam-results-change-params`}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{marginTop:20}}
                                        className={`mam-btn mam-change`}
                                        onClick={this.reset}
                                    > CHANGE
                                    </Button>
                                </div>
                                <ResultPage widgetConfig={this.widgetConfig} state={this.state} reset={this.reset} learnMore={this.learnMore} formatCurrency={this.formatCurrency} />
                            </div>
                        }
                        { this.state.loading && <LoadingScreen />}
                    </div>
                }
            </div>
        );
    }
}


const styles = theme => ({
    // isVeteranToggle: {
    //     background: 'transparent',
    //     border: 'solid 1px #fff',
    //     borderRadius: '20px',
    //     width: '100%',
    //     fontSize: '.65em'
    // },
    // isVeteranToggleSelected: {
    //     background: '#fff',
    //     color: '#000'
    // },
});

export default withStyles(styles)(AmountsPage);